export const address='https://site.api.ftizisbiomed.ru'
export const site_address='https://ftizisbiomed.ru'